import { makeRequest } from '../utils/apiUtils';
import queryString from 'query-string';

export const CLEAR_FILTERS = 'finance/CLEAR_FILTERS';
export const DELETE_FILTER = 'finance/DELETE_FILTER';
export const DELETE_FILTER_ITEM = 'finance/DELETE_FILTER_ITEM';
export const SET_FILTER = 'finance/SET_FILTER';
export const SET_APPLIED_FILTER = 'finance/SET_APPLIED_FILTER';
export const LOAD_SUBREQUESTS_BY_REQUEST_ID = 'finance/LOAD_SUBREQUESTS_BY_REQUEST_ID';
export const LOAD_SUBREQUESTS_BY_REQUEST_ID_SUCCESS = 'finance/LOAD_SUBREQUESTS_BY_REQUEST_ID_SUCCESS';
export const LOAD_SUBREQUESTS_BY_REQUEST_ID_FAIL = 'finance/LOAD_SUBREQUESTS_BY_REQUEST_ID_FAIL';
export const LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT = 'finance/LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT';
export const LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_SUCCESS = 'finance/LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_SUCCESS';
export const LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_FAIL = 'finance/LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_FAIL';

export function setFilter(filter) {
  return {
    type: SET_FILTER,
    filter,
  };
}

export function setAppliedFilter(filter) {
  return {
    type: SET_APPLIED_FILTER,
    filter
  }
}

export function clearFilters(filters) {
  return {
    type: CLEAR_FILTERS,
    filters
  }
}

export function deleteFilter(name, filters) {
  return {
    type: DELETE_FILTER,
    name,
    filters
  }
}

export function deleteFilterItem(name, value) {
  return {
    type: DELETE_FILTER_ITEM,
    name,
    value
  }
}

export function loadSubrequestsByRequestId({id, page, pageSize}) {
  return makeRequest(`/saduka/finance/interactedApplications?${queryString.stringify({
    id,
    page: page+1,
    perpage: pageSize,
  })}`, {
    types: [LOAD_SUBREQUESTS_BY_REQUEST_ID, LOAD_SUBREQUESTS_BY_REQUEST_ID_SUCCESS, LOAD_SUBREQUESTS_BY_REQUEST_ID_FAIL],
    options: {
      credentials: 'include'
    },
    id
  });
}

export function loadSubrequestsByRequestIdCount({id, page, pageSize}) {
  return makeRequest(`/saduka/finance/interactedApplications/count?${queryString.stringify({
    id,
  })}`, {
    types: [LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT, LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_SUCCESS, LOAD_SUBREQUESTS_BY_REQUEST_ID_COUNT_FAIL],
    options: {
      credentials: 'include'
    },
    id
  });
}
